<template>
  <div class="cv-container">
    <div class="title">
      <span class="cv-title">我的简历</span>
      <div class="more" v-if="cvList.length > 1" @click="recommendCv">全部简历</div>
    </div>
    <div class="no-cv" data-growing-container v-if="!isLogin || cvList.length === 0" @click="noCvClick">
      <span class="iconfont iconfasong" />
      <span>新建/导入简历</span>
    </div>
    <div class="online-cv" @click="goEditor" data-growing-container v-else>
      <div class="cv-container">
        <div class="cv-message">
          <div class="cv-avatar">
            <img :src="cvData.can_editable ? cvData.avatar_url || 'https://files.wondercv.com/mobile/cvs/cv-logo.png' : 'https://files.wondercv.com/expired-cv-min.png'" alt="">
          </div>
          <div class="cv-detail">
            <div class="cv-name">
              <div class="name">{{ cvData.cv_name || '未命名超级简历' }}</div>
              <span class="iconfont iconmore-horizontal" @click.stop="cvOperation" />
            </div>
            <div class="cv-score">
              <div class="score">{{ cvData.score === null ? 40 : cvData.score }}分</div>
              <div class="lang">{{ cvData.lang === 'cn' ? '中文简历' : '英文简历' }}</div>
            </div>
            <div class="update-at" v-if="hasOnlineCv && onlineCvDatas.length > 0">{{ updateTime | timeFormatFilter(true) }} 更新</div>
            <div class="update-at" v-else>{{ cvData.update_time | timeFormatFilter(true) }} 更新</div>
          </div>
        </div>
        <div :class="['set-online-cv', hasOnlineCv && onlineCvDatas.length > 0 ? 'privacy' : '']" v-if="cnCvsData.length">
          <div class="cv-tips" v-if="!hasOnlineCv || onlineCvDatas.length === 0">
            <div class="tips">
              <img src="https://files.wondercv.com/m/cvs/bell1.png" alt="">
              <span>将简历推荐给 HR 更易获得 offer</span>
            </div>
            <div class="recommend-btn" @click.stop="setOnlineCv">
              去推荐
            </div>
          </div>
          <div class="cv-tips" v-else-if="cvData.can_editable">
            <div class="tips">
              <span>该简历正在被推荐给 HR</span>
            </div>
            <div class="recommend-btn set-btn" @click.stop="toRecommendCvPreview">
              查看
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { envMixin, loginMixin } from '@/assets/js/mixin/global'
import {mapState} from "vuex";
export default {
  name: "cvOperation",
  mixins: [loginMixin, envMixin],
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    onlineCvToken: {
      type: String,
      default: ""
    },
    // onlineCvTime: {
    //   type: String,
    //   default: ""
    // }
  },
  data() {
    return {

    }
  },
  watch: {

  },
  computed: {
    ...mapState('cv', [ 'onlineCvData', 'onlineVisibility', 'onlineCvValid' ]),
    ...mapState('cvIndex', [ 'cvList' ]),
    cvData() {
      let onlineCvData = this.cvList.filter(cv => cv.token === this.onlineCvToken)
      if (this.hasOnlineCv && onlineCvData.length > 0) {
        return onlineCvData[0]
      } else {
        return this.cvList[0]
      }
    },
    // 当前的在线简历是否存在草稿简历列表中（兼容老版本删除草稿简历在线简历还在的情况）
    onlineCvDatas() {
      return this.cvList.filter(cv => cv.token === this.onlineCvToken)
    },
    // 是否有在线简历
    hasOnlineCv () {
      if (this.onlineCvData && Object.keys(this.onlineCvData).length && !this.onlineVisibility) {
        return Object.keys(this.onlineCvData).length
      }
    },
    // 在线简历数据
    cvInfo () {
      if (this.hasOnlineCv) {
        return this.onlineCvData.resume.info
      }
    },
    // 在线简历更新时间
    updateTime () {
      if (this.hasOnlineCv) return `${ this.onlineCvData.resume?.updated_at }`
    },
    // 中文非导师简历列表
    cnCvsData () {
      return this.cvList.filter(item => item.lang === 'cn' && !item.is_mentor && item.can_editable)
    },
    // 是否显示更新按钮
    updateShow () {
      let onlineCvTime = this.hasOnlineCv ? moment(this.onlineCvData.resume?.updated_at).format('YYYYMMDDHHmmss') : this.onlineCvData?.updated_at && moment(this.onlineCvData?.updated_at).format('YYYYMMDDHHmmss')

      for (let i = 0; i < this.cnCvsData.length; i++) {
        let cvTime = moment(this.cnCvsData[i].update_time).format('YYYYMMDDHHmmss')
        if (cvTime > onlineCvTime) return true
      }
    },
    // 在线简历教育学校
    uniSchool () {
      if (this.cvInfo.education_experiences.length) {
        return this.cvInfo.education_experiences[0].cust_uni_name || this.cvInfo.education_experiences[0].school.cn
      }
    },
    // 在线简历学历
    degree () {
      if (this.cvInfo.education_experiences.length) {
        return this.cvInfo.education_experiences[0].cust_degree || this.cvInfo.education_experiences[0].degree_name.cn
      }
    }
  },
  mounted() {
    // setTimeout(() => {
    //   console.log(this.onlineCvDatas,"============>online")
    //   console.log(this.onlineCvToken,"============>token")
    //   console.log(this.onlineVisibility,"============>visibility")
    //   console.log(this.hasOnlineCv,"============>hasOnlineCv")
    // },2000)
  },
  methods: {
    // 新建或导入简历
    noCvClick() {
      if (this.isLogin) {
        this.$emit('addCv')
      } else {
        this.verifyLogin(this.isLogin,() => {
          this.$router.push('/cvs')
        }, `/cvs`)
      }
    },
    // 跳转隐私设置
    setPrivacy() {
      this.$fn.jump(
        `${window.location.origin}/account/privacy`,
        () => {
          this.$router.push('/account/privacy')
        }
      )
    },
    // 跳转简历编辑
    goEditor() {
      this.$emit('goEditor', this.cvData)
      // this.$router.push(`/cvs/${this.cvData.token}/editor`)
    },
    // 设置在线简历
    recommendCv() {
      this.$emit('showCvsRecommend')
    },
    setOnlineCv() {
      this.$emit('setOnlineCv')
    },
    // 操作当前简历
    cvOperation() {
      this.$emit('operation', this.cvData)
    },
    toRecommendCvPreview() {
      this.$fn.jump(
        `${window.location.origin}/cvs/online/${ this.cvData.token }/preview`,
        () => {
          this.$router.push(`/cvs/online/${ this.cvData.token }/preview`)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/variable';
@import '@/assets/scss/global/mixin';
.cv-container {
  width: 100%;
  height: auto;
  //padding: 0 8px;
  .title {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cv-title {
      color: #404040;
      font-size: 18px;
      font-weight: 500;
    }
    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 76px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #ececec;
      font-size: 13px;
      color: #606060;
    }
  }
  .no-cv {
    width: 327px;
    height: 80px;
    margin-top: 12px;
    border: 1px dashed #669BFF;
    background-color: #F5F8FF;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #4183ff;
    span:last-child {
      margin-left: 10px;
    }
  }
  .online-cv {
    width: 327px;
    // height: 146px;
    padding: 16px 14px;
    box-shadow: 0 1px 10px 0 rgba(3, 47, 129, 0.08);
    border-radius: 6px;
    .cv-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .cv-message {
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .cv-avatar {
          width: 56px;
          height: 70px;
          border-radius: 4px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
        .cv-detail {
          width: calc(100% - 66px);
          height: 100%;
          .cv-name {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .name {
              color: #404040;
              font-size: 16px;
              font-weight: 500;
              @include ellipsis(calc(100% - 50px))
            }
            .iconfont {
              color: #cfcfcf;
              font-size: 28px;
            }
          }
          .cv-score {
            display: flex;
            align-items: center;
            font-size: 11px;
            .score {
              //width: 41px;
              padding: 0 8px;
              height: 20px;
              background: #FFF6F4;
              border-radius: 2px;
              line-height: 20px;
              text-align: center;
              color: #ff6644;
              font-weight: 500;
            }
            .lang {
              //width: 60px;
              padding: 0 8px;
              margin-left: 12px;
              height: 20px;
              background: #F5F8FF;
              border-radius: 2px;
              line-height: 20px;
              color: #669BFF;
              font-weight: 500;
            }
          }
          .update-at {
            font-size: 11px;
            color: #9c9c9c;
            margin-top: 7px;
          }
        }
      }
      .set-online-cv {
        width: 100%;
        height: 28px;
        border-radius: 14px;
        background-color: #fff6f4;
        color: #ff6644;
        margin-top: 16px;
        .cv-tips {
          width: 100%;
          height: 100%;
          padding-left: 12px;
          font-size: 13px;
          line-height: 28px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            width: 11px;
            height: 12px;
            object-fit: fill;
          }
          .tips {
            display: flex;
            align-items: center;
            span {
              margin-left: 5px;
            }
          }
          .recommend-btn {
            //width: 66px;
            padding: 0 12px;
            height: 100%;
            border-radius:14px;
            background-color: #ff6644;
            color: #fff;
            font-size: 14px;
            text-align: center;
            line-height: 28px;
          }
          .set-btn {
            background-color: #fff;
            color: #9c9c9c;
            border: 1px solid #efefef;
          }
        }
      }
      .privacy {
        background-color: #f9f9f9;
        color: #9c9c9c;
      }
    }
  }
}
</style>
